module.exports = __webpack_public_path__ + "img/banner.fcffee4e.png";